<template>
  <div class="cont">
    <Navbar :dialogLoginVisible.sync="loginFormShow"></Navbar>
    <div class="d-flex" style="justify-content: center;position: relative;">
      <div style="border-radius: 50%;width: 44px;height: 44px;justify-content: center;align-items: center;background: #1B1D2E;position: absolute;left: 0;top: 40px;z-index: 9;cursor: pointer;" class="d-flex" @click="homeBack">
        <el-image style="height: 24px;width: 24px;" :src="require('../assets/img/explore/back.png')" >
            <div slot="placeholder" class="image-slot"></div>
          </el-image>
      </div>

      <div class="info_cont d-flex">
        <div class="l">
          <el-image style="height: calc( 100vh - 300px );border-radius: 20px 0px 0px 20px;" :src="url" v-if="url" @error="imgerr">
            <div slot="placeholder" class="image-slot"></div>
          </el-image>
        </div>
        <div class="r">
          <div class="line d-flex"  style="align-items: center;margin-bottom: 10px;justify-content: flex-end;">
            <el-button  type="primary"  round style="background: #fff;color: #000;width: 100%;" @click="download_click">下载</el-button>
          </div>
        </div>
      </div>
    </div>


    <div class="waterfall_title">
      相关推荐
    </div>

    <MyWaterfall @loginFormShowChange="loginFormShowChange"></MyWaterfall>

    <LoginForm :dialogLoginVisible.sync="loginFormShow" v-if="loginFormShow"></LoginForm>

    <ElBacktop></ElBacktop>



  </div>
</template>

<script>
import { md_list , st_list  } from "@/api/taskImage";
import { copyToClip  } from "@/utils/bose";
import {  painting_download_req  } from "@/api/square";

import Navbar from "@/components/Navbar" ;
import LoginForm from "@/components/LoginForm" ;
import MyWaterfall from "@/components/MyWaterfall" ;
import ElBacktop from "@/components/ElBacktop"


export default {
  components: {
    Navbar,
    LoginForm , 
    MyWaterfall ,
    ElBacktop
  },
  data(){
    return {
      params : {} , 
      url : "" , 
      loginFormShow : false , 
      imgMd5 : undefined , 
    }
  } ,
  computed:{
    tokenVuex() {
      // 存储位置： store.state.{模块名,在store/index.js中module下的}.{state中定义的属性}
      return this.$store.state.user.token
    }
  },
  mounted(){
    this.params = this.$route.params
    this.url =   this.params.url 
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    if( this.params.md5 ){
      this.imgMd5 = this.params.md5
    }
    if( !this.url ){
      this.$router.replace({ path: '/' });
      return
    }
  } ,
  methods : {
    loginFormShowChange(data) {
      this.loginFormShow = data;
    } ,
    download_click(){
      if( this.imgMd5 ){
        this.download_click2()
        return
      }
      const image = new Image()
      image.setAttribute('crossOrigin', 'anonymous')
      image.src = this.url
      image.onload = () => {
        const canvas = document.createElement('canvas')
        canvas.width = image.width
        canvas.height = image.height
        const ctx = canvas.getContext('2d')
        ctx.drawImage(image, 0, 0, image.width, image.height)
        const url = canvas.toDataURL('image/png')
        const a = document.createElement('a')
        a.href = url
        a.download = 'image.png'
        a.click()
      }
    } ,
    download_click2( flag ){
      // painting_download_req(  )
      painting_download_req({
        imgMd5 : this.imgMd5 ,
        isMask : false
      }).then( res => {
        const image = new Image()
        image.setAttribute('crossOrigin', 'anonymous')
        image.src = res.data
        image.onload = () => {
          const canvas = document.createElement('canvas')
          canvas.width = image.width
          canvas.height = image.height
          const ctx = canvas.getContext('2d')
          ctx.drawImage(image, 0, 0, image.width, image.height)
          const url = canvas.toDataURL('image/png')
          const a = document.createElement('a')
          a.href = url
          a.download = 'image.png'
          a.click()
        }
      } )

      return ;
      

    } ,
    imgerr(){
      this.$router.replace({
        path: "/", // ⚠️注：这里不能用path路径，只能用name【请对照router.js中的路由规则中的name项】，否则取不到传过去的数据
      });
    } ,
    homeBack(){
      // this.$router.push({
      //   path: `/`,
      // })

      this.$router.go(-1)
      
    },

  }
}

</script>


<style lang="scss" scoped>
.cont {
  padding: 60px 84px 0;
  box-sizing: border-box;
}

.info_cont {
  min-width: 500px;
  // height: 470px;
  background: #1B1D2E;
  border-radius: 20px;
  margin: 0 auto;
  margin-top: 40px;
  .r {
    width: 120px;
    padding: 12px 15px;
    box-sizing: border-box;

  }
}


.info  {
  text-align: left;
  padding: 12px;
  box-sizing: border-box;
  font-size: 14px;
  overflow: hidden;
  height: 100%;
  background: #111225;

  .title {
    box-sizing: border-box;
    padding: 0 15px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    position: relative;
  }

  .scroll-cont{
    margin-top:8px;
    height: calc(100% - 25px);
    position: relative;
  }
  .scroll-cont {
    overflow: hidden;
  }
  .scroll-cont::-webkit-scrollbar {
    width: 5px;
    display: flex;
  }
  .scroll-cont::-webkit-scrollbar-thumb {
  }
  .scroll-cont:hover {
    overflow-y: auto;
    // width: calc(100% - 1px )
  }
}


.waterfall_title {
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 33px;
  margin-top: 43px;
  margin-bottom: 16px;
  text-align: center;
}
</style>